export const SectionCounter = ({ active }) => {
  const num = String(active + 1).padStart(3, "0");
  return (
    <div className="section-counter hidden lg:flex" data-testid="section-counter">
      <span className="counter-num">{num} / 006</span>
      <span className="counter-line" />
    </div>
  );
};
